import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import {
  Grid, TextField, Button, Box, Typography, Container, FormControl, FormHelperText, Select,
  InputLabel, FilledInput, Link, Radio, RadioGroup, FormControlLabel, InputAdornment,
  FormLabel
} from '@mui/material';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ReCAPTCHA from "react-google-recaptcha";
import EmailAuthenticator from '../common/EmailAuthenticator.js';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker'; // Import TimePicker
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import { fontSize, styled } from '@mui/system';
import moment from 'moment';

// Styled components for better visual representation matching the screenshot
const FormContainer = styled(Container)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(4),
  borderRadius: theme.spacing(1),
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

export default function EngagementForm({ internalUser }) {
  const [fields, setFields] = useState({
    requestorName: '', requestorTitle: '', requestorEmail: '', requestorPhoneNumber: '',
    requestType: 'Event',
    eventPointOfContact: '', proposedEventDate: null, proposedAltEventDate: null,
    proposedEventTime: null, proposedEventDuration: '', proposedEventLocation: '',

    eventTitle: null,
    eventType: null, otherEventType: '',
    eventFormat: null, otherEventFormat: '',
    pressInAttendance: null, recordedLivestreamed: null, howItWillBeUsed: null,

    attendeeName: '', organizationName: '', organizationDetails: '', topic: '', additionalAttendees: '',
    meetingWithOtherOffice: null, otherOfficeName: '',

    inPerson: null, appliedFinancialAssistanceBefore: null,

    unclearedForeignNationals: null, clearanceObtained: null,

    // To be removed
    proposedEventFormat: null, otherProposedEventFormat: '',
    hgeoAreasOfInterest: '',
    bios: '', noteForEA: ''
  });

  const [dateError, setDateError] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false); // To trigger validation on submit
  const [emailVerified, setEmailVerified] = useState(false);
  const [verifyEmail, setVerifyEmail] = useState(false);
  const [cpVerified, setCpVerified] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [saving, setSaving] = React.useState(false);
  const [submitError, setSubmitError] = useState(false);

  const appliedAssistanceRef = useRef(null);
  // const [file, setFile] = useState(null);
  // const [file_errorText, setFile_errorText] = useState(null);

  /*const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };*/

  // const today = moment().format('YYYY-MM-DD');

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitted(true);
    // Here you would typically handle the form submission, 
    // e.g., send data to an API or perform validation.
    var obj = { ...fields };

    if (!obj.appliedFinancialAssistanceBefore) {
      appliedAssistanceRef.current?.focus();
      return;
    }

    if (!obj.requestType || !obj.appliedFinancialAssistanceBefore || !obj.inPerson) {
      return;
    }
    if (obj.requestType === 'Event' && (!obj.eventType || !obj.eventFormat || !obj.pressInAttendance || !obj.recordedLivestreamed)) {
      return;
    }
    if (obj.requestType === 'Meeting' && !obj.meetingWithOtherOffice)
      return;

    if(internalUser){
      obj.noteForEA = `
        <div style="margin-bottom: 4px;">
            <span style="color: blue;">${internalUser.name} (${ moment().format("M/D/YYYY h:mm A")}):</span>
            Request Submitted
        </div>
        <div style="margin-bottom: 4px;">
            <span style="color: blue;">${internalUser.name} (${ moment().format("M/D/YYYY h:mm A")}):</span>
            ${obj.noteForEA}
        </div>
      `;
    }

    console.log(obj);
    sendData(obj);
    /*
    let reader = new FileReader();
    reader.addEventListener("load", function () {
      if (document.getElementById('fileForUpload').files[0].name.toLowerCase().indexOf(".pdf") === -1) {
        setFile_errorText('Only PDF files are allowed at this time.');
        return;
      }
      if (document.getElementById('fileForUpload').files[0].name.length > 50) {
        setFile_errorText('File name too long. Maximum length allowed: 50');
        return;
      }

      console.log(11111);
      let data = {
        fields: JSON.stringify(obj),
        fileName: document.getElementById('fileForUpload').files[0].name,
        fileContent: reader.result.substr(reader.result.indexOf(',') + 1),
      };

      console.log(2222222);
      sendData(data);
    }, false);

    if (document.getElementById('fileForUpload').files.length > 0) {
      reader.readAsDataURL(document.getElementById('fileForUpload').files[0]);
    } else {
      let data = {
        fields: JSON.stringify(obj),
      };
      sendData(data);
    }
    */

  };

  function sendData(data) {
    setSaving(true);
    setSubmitError(false);
    axios.post("EngagementTracker/SaveForm", data)
      .then((res) => {
        setFormSubmitted(true);
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // Or 'auto' for an instant jump
        });
      }
      )
      .catch((res) => {
        console.log(res);
        console.log(res.error)
        setSubmitError(true);
        // setAlert('Error saving Tanker Detail', 'error', res, true);
      })
      .finally(() => {
        setSaving(false);
      })
  }

  function handleChange(event) {
    let obj = { ...fields };
    if (event.target.name === 'requestorPhoneNumber') {
      var x = event.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      obj[event.target.name] = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    } else {
      obj[event.target.name] = event.target.value;
    }
    setFields(obj);
  };

  const captchaVerified = () => {
    setCpVerified(true);
  };

  return (
    <FormContainer maxWidth="lg" style={{ textAlign: 'left' }}>
      {
        verifyEmail === true &&
        <EmailAuthenticator emailAddr={fields.requestorEmail} setEmailVerified={setEmailVerified} verifyEmail={verifyEmail} setVerifyEmail={setVerifyEmail} />
      }

      <Typography variant="h6" component="h6" gutterBottom>
        Hydrocarbons and Geothermal Energy Office (HGEO) Scheduling Request Form
      </Typography>
      {/* <Typography variant="body2">
        When you submit this form, it will not automatically collect your details like name and email address unless you provide it yourself. <br />
      </Typography> */}
      {
        !formSubmitted &&
        <div>
          <Box
            sx={{
              mt: 3,
              mb: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            {/* Left */}
            <Typography variant="body2">
              <span style={{ color: 'red' }}>*</span> Required
            </Typography>

            {/* Right - Internal users only */}
            {internalUser && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <VerifiedUser
                  sx={{
                    color: 'green',
                    fontSize: 20
                  }}
                />

                <Typography variant="body2">
                  {internalUser.name}
                </Typography>
              </Box>
            )}
          </Box>
          <form onSubmit={handleSubmit}>
            <Box component="fieldset" sx={{ borderColor: 'grey.200', borderRadius: 1 }}>
              <legend style={{ fontSize: '14px' }}>Requester Information</legend>
              <Grid container spacing={4}>
                <Grid item="true" size={{ md: 12, lg: 6 }}>
                  <FormControl required fullWidth>
                    <TextField autoFocus
                      label="Requester Name"
                      variant="filled"
                      placeholder="List your first and last name."
                      required
                      name='requestorName'
                      value={fields && fields.requestorName}
                      onChange={handleChange}
                      helperText={
                        internalUser
                          ? "List Requester first and last name."
                          : "List your first and last name."
                      }
                      slotProps={{
                        htmlInput: { maxLength: 100 }
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item="true" size={{ md: 12, lg: 6 }}>
                  <FormControl required fullWidth>
                    <TextField
                      label="Requester Title"
                      variant="filled"
                      required
                      name='requestorTitle'
                      value={fields && fields.requestorTitle}
                      onChange={handleChange}
                      slotProps={{
                        htmlInput: { maxLength: 100 }
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item="true" size={{ md: 12, lg: 6 }}>
                  <FormControl required fullWidth>
                    <InputLabel htmlFor="idRequestorEmail">Requester Email</InputLabel>
                    <FilledInput
                      id="idRequestorEmail"
                      type="email"
                      name='requestorEmail'
                      style={{ height: '50px' }}
                      value={fields && fields.requestorEmail}
                      onChange={handleChange}
                      required
                      endAdornment={
                        !internalUser &&
                        <InputAdornment position="end">
                          {
                            emailVerified ? <VerifiedUser style={{ color: 'green' }} />
                              :
                              <Button variant='contained' disabled={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.requestorEmail)}
                                onClick={() => setVerifyEmail(true)}
                              >Verify</Button>
                          }
                        </InputAdornment>
                      }
                      inputProps={{ maxLength: 100 }}
                    />
                    <FormHelperText id="component-helper-text">
                      {
                        internalUser
                          ? "Requester Email address."
                          : "Email address must be verified before submitting the form."
                      }
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item="true" size={{ md: 12, lg: 6 }}>
                  <FormControl required fullWidth>
                    <TextField
                      label="Requester Phone Number"
                      variant="filled"
                      type="tel"
                      name='requestorPhoneNumber'
                      required
                      value={fields && fields.requestorPhoneNumber}
                      onChange={handleChange}
                      slotProps={{
                        htmlInput: { maxLength: 50 }
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item="true" size={{ md: 12, lg: 6 }}>
                  <Box sx={{ backgroundColor: '#f5f9fd', padding: '10px' }}>
                    <FormControl required
                      name='requestType'
                      onChange={(event) => {
                        setFields({
                          ...fields, [event.target.name]: event.target.value,
                        });
                      }}
                      error={isSubmitted && !fields.requestType}
                    >
                      <FormLabel>What is the Request for?</FormLabel>
                      <RadioGroup row name="requestType" required value={fields.requestType}>
                        <FormControlLabel value="Event" control={<Radio />} label="Event" />
                        <FormControlLabel value="Meeting" control={<Radio />} label="Meeting" />
                      </RadioGroup>

                      {((isSubmitted && !fields.requestType)) ?
                        <FormHelperText>This field is required</FormHelperText> // Display error message
                        :
                        <></>
                        // <FormHelperText>Select to continue.</FormHelperText>
                      }
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item="true" size={{ md: 12, lg: 6 }}>
                  <Box sx={{ backgroundColor: '#f5f9fd', padding: '10px' }}>
                    <FormControl style={{ fontSize: '12px' }}
                      onChange={(event) => {
                        setFields({
                          ...fields, [event.target.name]: event.target.value,
                        });
                      }}
                      name='appliedFinancialAssistanceBefore'
                      error={isSubmitted && !fields.appliedFinancialAssistanceBefore}
                      required
                    >
                      <FormLabel id="appliedFinancialAssistanceBefore">Have you or your organization previously applied for financial assistance from the DOE?</FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="appliedFinancialAssistanceBefore"
                        name='appliedFinancialAssistanceBefore'
                        required
                        value={fields.appliedFinancialAssistanceBefore}
                      >
                        <FormControlLabel
                          control={
                            <Radio
                              inputRef={appliedAssistanceRef}
                            />
                          }
                          value="Yes" label="Yes" />
                        <FormControlLabel value="No" control={<Radio />} label="No" />
                      </RadioGroup>
                      {((isSubmitted && !fields.appliedFinancialAssistanceBefore)) && (
                        <FormHelperText>This field is required</FormHelperText> // Display error message
                      )}
                    </FormControl>
                  </Box>
                </Grid>

              </Grid>
            </Box>
            <br />

            {
              fields.requestType &&
              <>
                <div className="separator">{fields.requestType} Information</div>

                <Box style={{ margin: '10px 20px 20px 20px' }}>
                  <Grid container spacing={4} >
                    {
                      fields.requestType === 'Event' &&
                      <Grid item="true" size={{ md: 12, lg: 6 }}>
                        <FormControl fullWidth>
                          <TextField
                            label="Event Title"
                            rows={3}
                            name='eventTitle'
                            value={fields && fields.eventTitle}
                            onChange={handleChange}
                            variant="filled"
                            slotProps={{
                              htmlInput: { maxLength: 250 }
                            }}
                          />
                        </FormControl>
                      </Grid>
                    }
                    <Grid item="true" size={{ md: 12, lg: 6 }}>
                      <FormControl fullWidth>
                        <TextField
                          label={fields.requestType === "Meeting" ? "Meeting Point of Contact" : "Event Point of Contact"}
                          rows={3}
                          name='eventPointOfContact'
                          value={fields && fields.eventPointOfContact}
                          onChange={handleChange}
                          variant="filled"
                          slotProps={{
                            htmlInput: { maxLength: 250 }
                          }}
                        />
                      </FormControl>
                    </Grid>
                    {
                      fields.requestType === 'Event' &&
                      <>
                        <Grid item="true" size={{ md: 12, lg: 6 }}>
                          <Box sx={{ backgroundColor: '#f5f9fd', padding: '10px' }}>
                            <FormControl style={{ fontSize: '12px' }}
                              onChange={(event) => {
                                setFields({
                                  ...fields, [event.target.name]: event.target.value,
                                  'otherEventType': ''
                                });
                              }}
                              name='eventType'
                              error={isSubmitted && !fields.eventType}
                              required
                            >
                              <FormLabel id="eventType">Event Type</FormLabel>
                              <RadioGroup
                                row
                                aria-labelledby="eventType"
                                name='eventType'
                                required
                                value={fields.eventType}
                              >
                                <FormControlLabel value="Conference" control={<Radio />} label="Conference" />
                                <FormControlLabel value="Workshop" control={<Radio />} label="Workshop" />
                                <FormControlLabel value="Roundtable" control={<Radio />} label="Roundtable" />
                                <FormControlLabel value="Fireside Chat" control={<Radio />} label="Fireside Chat" />
                                <FormControlLabel value="Other" control={<Radio />} label="Other" />
                              </RadioGroup>
                              {((isSubmitted && !fields.eventType)) && (
                                <FormHelperText>This field is required</FormHelperText> // Display error message
                              )}
                            </FormControl>
                            {
                              fields && fields.eventType && fields.eventType === 'Other' &&
                              <TextField name='otherEventType' size="small" style={{ marginTop: '20px' }}
                                onChange={(event) => {
                                  setFields({
                                    ...fields, [event.target.name]: event.target.value,
                                  });
                                }}
                                placeholder='Please Specify'
                                slotProps={{
                                  htmlInput: { maxLength: 100 }
                                }}
                                required />
                            }
                          </Box>
                        </Grid>
                        <Grid item="true" size={{ md: 12, lg: 6 }}>
                          <Box sx={{ backgroundColor: '#f5f9fd', padding: '10px' }}>
                            <FormControl style={{ fontSize: '12px' }}
                              onChange={(event) => {
                                setFields({
                                  ...fields, [event.target.name]: event.target.value,
                                  'otherEventFormat': ''
                                });
                              }}
                              name='eventFormat'
                              error={isSubmitted && !fields.eventFormat}
                              required
                            >
                              <FormLabel id="eventFormat">Event Format</FormLabel>
                              <RadioGroup
                                row
                                aria-labelledby="eventFormat"
                                name='eventFormat'
                                required
                                value={fields.eventFormat}
                              >
                                <FormControlLabel value="Keynote" control={<Radio />} label="Keynote" />
                                <FormControlLabel value="Speaker" control={<Radio />} label="Speaker" />
                                <FormControlLabel value="Panelist" control={<Radio />} label="Panelist" />
                                <FormControlLabel value="Participant" control={<Radio />} label="Participant" />
                                <FormControlLabel value="Other" control={<Radio />} label="Other" />
                              </RadioGroup>
                              {((isSubmitted && !fields.eventFormat)) && (
                                <FormHelperText>This field is required</FormHelperText> // Display error message
                              )}
                            </FormControl>
                            {
                              fields && fields.eventFormat && fields.eventFormat === 'Other' &&
                              <TextField name='otherEventFormat' size="small" style={{ marginTop: '20px' }}
                                onChange={(event) => {
                                  setFields({
                                    ...fields, [event.target.name]: event.target.value,
                                  });
                                }}
                                placeholder='Please Specify'
                                slotProps={{
                                  htmlInput: { maxLength: 100 }
                                }}
                                required />
                            }
                          </Box>
                        </Grid>
                        <Grid item="true" size={{ md: 12, lg: 6 }}>
                          <Box sx={{ backgroundColor: '#f5f9fd', padding: '10px' }}>
                            <FormControl style={{ fontSize: '12px' }}
                              onChange={(event) => {
                                setFields({
                                  ...fields, [event.target.name]: event.target.value,
                                });
                              }}
                              name='pressInAttendance'
                              error={isSubmitted && !fields.pressInAttendance}
                              required
                            >
                              <FormLabel id="pressInAttendance">Press in attendance?</FormLabel>
                              <RadioGroup
                                row
                                aria-labelledby="pressInAttendance"
                                name='pressInAttendance'
                                required
                                value={fields.pressInAttendance}
                              >
                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                <FormControlLabel value="No" control={<Radio />} label="No" />
                              </RadioGroup>
                              {((isSubmitted && !fields.pressInAttendance)) && (
                                <FormHelperText>This field is required</FormHelperText> // Display error message
                              )}
                            </FormControl>
                          </Box>
                        </Grid>
                        <Grid item="true" size={{ md: 12, lg: 6 }}>
                          <Box sx={{ backgroundColor: '#f5f9fd', padding: '10px' }}>
                            <FormControl style={{ fontSize: '12px' }}
                              onChange={(event) => {
                                setFields({
                                  ...fields, [event.target.name]: event.target.value,
                                });
                              }}
                              name='recordedLivestreamed'
                              error={isSubmitted && !fields.recordedLivestreamed}
                              required
                            >
                              <FormLabel id="recordedLivestreamed">Recorded / Livestreamed?</FormLabel>
                              <RadioGroup
                                row
                                aria-labelledby="recordedLivestreamed"
                                name='recordedLivestreamed'
                                required
                                value={fields.recordedLivestreamed}
                              >
                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                <FormControlLabel value="No" control={<Radio />} label="No" />
                              </RadioGroup>
                              {((isSubmitted && !fields.recordedLivestreamed)) && (
                                <FormHelperText>This field is required</FormHelperText> // Display error message
                              )}
                            </FormControl>
                          </Box>
                        </Grid>
                        {
                          fields && fields.recordedLivestreamed && fields.recordedLivestreamed === 'Yes' &&
                          <Grid item="true" size={{ md: 12, lg: 6 }}>
                            <FormControl fullWidth>
                              <TextField
                                label="Specify how it will be used?"
                                rows={3}
                                name='howItWillBeUsed'
                                value={fields && fields.howItWillBeUsed}
                                onChange={handleChange}
                                variant="filled"
                                slotProps={{
                                  htmlInput: { maxLength: 250 }
                                }}
                              />
                            </FormControl>
                          </Grid>
                        }
                      </>
                    }
                  </Grid>
                </Box>

                <div className="separator">Proposed Scheduling</div>
                <Box style={{ margin: '10px 20px 20px 20px' }}>
                  <Grid container spacing={4} >
                    <Grid item="true" size={{ md: 12, lg: 6 }} >
                      <FormControl required style={{ width: '250px' }}>
                        <TextField
                          label="Proposed Date Option"
                          variant="filled"
                          placeholder="Enter the date"
                          required
                          name='proposedEventDate'
                          value={fields && fields.proposedEventDate}
                          onChange={handleChange}
                          slotProps={{
                            htmlInput: { maxLength: 100 }
                          }}
                        />
                      </FormControl>
                      <FormControl required style={{ marginLeft: '5px', width: '250px' }}>
                        <TextField
                          label="Proposed Time"
                          variant="filled"
                          placeholder="Enter the time"
                          required
                          name='proposedEventTime'
                          value={fields && fields.proposedEventTime}
                          onChange={handleChange}
                          slotProps={{
                            htmlInput: { maxLength: 100 }
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item="true" size={{ md: 12, lg: 6 }} >
                      <FormControl fullWidth>
                        <TextField type='text'
                          label="Proposed Alternative Date/Time Options"
                          variant="filled"
                          fullWidth
                          name='proposedAltEventDate'
                          value={(fields && fields.proposedAltEventDate) || ''}
                          onChange={handleChange}
                          slotProps={{
                            htmlInput: { maxLength: 100 }
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item="true" size={{ md: 12, lg: 6 }}>
                      <FormControl fullWidth>
                        <TextField
                          label="Proposed Duration"
                          rows={3}
                          name='proposedEventDuration'
                          value={fields && fields.proposedEventDuration}
                          onChange={handleChange}
                          variant="filled"
                          helperText='Include the estimated length of the event/meeting time. For example, "30 minutes"'
                          slotProps={{
                            htmlInput: { maxLength: 250 }
                          }}
                        />
                      </FormControl>
                    </Grid>
                    {
                      fields.requestType === 'Event' &&
                      <>
                        <Grid item="true" size={{ md: 12, lg: 6 }}>
                          <FormControl fullWidth required>
                            <TextField required
                              label="Proposed Location"
                              rows={3}
                              name='proposedEventLocation'
                              value={fields && fields.proposedEventLocation}
                              onChange={handleChange}
                              variant="filled"
                              helperText='Include venue, city and address'
                              slotProps={{
                                htmlInput: { maxLength: 250 }
                              }}
                            />
                          </FormControl>
                        </Grid>
                      </>
                    }
                  </Grid>
                </Box>

                <div className="separator">Additional Information</div>

                <Box style={{ margin: '10px 20px 0px 20px' }}>
                  <Grid container spacing={4}>
                    <Grid item="true" size={{ md: 12, lg: 6 }}>
                      <FormControl fullWidth required>
                        <TextField
                          label="Organization Name"
                          rows={3}
                          required
                          name='organizationName'
                          value={fields && fields.organizationName}
                          onChange={handleChange}
                          variant="filled"
                          helperText="Provide name of your organization."
                          slotProps={{
                            htmlInput: { maxLength: 250 }
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item="true" size={{ md: 12, lg: 6 }}>
                      <FormControl fullWidth required>
                        <TextField
                          label="Organization Details"
                          multiline
                          rows={3}
                          required
                          name='organizationDetails'
                          value={fields && fields.organizationDetails}
                          onChange={handleChange}
                          variant="filled"
                          helperText="Provide quick description of your organization."
                          slotProps={{
                            htmlInput: { maxLength: 250 }
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item="true" size={{ md: 12, lg: 6 }}>
                      <FormControl fullWidth required>
                        <TextField
                          label="Topic & Objective"
                          multiline
                          rows={3}
                          name='topic'
                          required
                          value={fields && fields.topic}
                          onChange={handleChange}
                          variant="filled"
                          helperText="Include Topic, Objective, & Benefit to DOE goals and priorities"
                        />
                      </FormControl>
                    </Grid>
                    <Grid item="true" size={{ md: 12, lg: 6 }}>
                      <FormControl fullWidth required>
                        <TextField
                          label="Attendee Name"
                          multiline
                          rows={3}
                          name='attendeeName'
                          required
                          slotProps={{
                            htmlInput: { maxLength: 250 }
                          }}
                          value={fields && fields.attendeeName}
                          onChange={handleChange}
                          variant="filled"
                          helperText="Specify Role/Title/SME"
                        />
                      </FormControl>
                    </Grid>
                    <Grid item="true" size={{ md: 12, lg: 6 }}>
                      <Box sx={{ backgroundColor: '#f5f9fd', padding: '10px' }}>
                        <FormControl style={{ fontSize: '12px' }}
                          onChange={(event) => {
                            setFields({
                              ...fields, [event.target.name]: event.target.value,
                              'additionalAttendees': ''
                            });
                          }}
                          required
                          name='inPerson'
                          aria-labelledby="inPerson"
                          error={isSubmitted && !fields.inPerson}
                        >
                          <FormLabel id="inPerson">In Person or Virtual</FormLabel>
                          <RadioGroup
                            row
                            name='inPerson'
                            required
                            value={fields.inPerson}
                          >
                            <FormControlLabel value="In Person" control={<Radio />} label="In Person" />
                            <FormControlLabel value="Virtual" control={<Radio />} label="Virtual" />
                          </RadioGroup>
                          {((isSubmitted && !fields.inPerson)) && (
                            <FormHelperText>This field is required</FormHelperText>
                          )}
                        </FormControl>
                      </Box>
                    </Grid>
                    {
                      fields.inPerson === 'In Person' &&
                      <Grid item="true" size={{ md: 12, lg: 6 }}>
                        <FormControl fullWidth required>
                          <TextField required
                            label="Additional Attendees"
                            multiline
                            rows={3}
                            name='additionalAttendees'
                            value={fields && fields.additionalAttendees}
                            onChange={handleChange}
                            variant="filled"
                            helperText={fields.requestType === 'Event' ?
                              "Expected number, demographics, notable attendees" :
                              "Full legal names, emails, and citizenship (for building clearance)"
                            }
                          />
                        </FormControl>
                      </Grid>
                    }
                    {/* {
                      fields.inPerson === 'In Person' &&
                      <Grid item="true" size={{ md: 12, lg: 6 }}>
                        <Box sx={{ backgroundColor: '#f5f9fd', padding: '10px' }}>
                          <FormControl style={{ fontSize: '12px' }}
                            onChange={(event) => {
                              setFields({
                                ...fields, [event.target.name]: event.target.value,
                                'otherOfficeName': ''
                              });
                            }}
                            required
                            name='unclearedForeignNationals'
                            aria-labelledby="unclearedForeignNationals"
                            error={isSubmitted && !fields.unclearedForeignNationals}
                          >
                            <FormLabel id="unclearedForeignNationals">Are any of the visitors uncleared foreign nationals?</FormLabel>
                            <RadioGroup
                              row
                              name='unclearedForeignNationals'
                              required
                              value={fields.unclearedForeignNationals}
                            >
                              <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                              <FormControlLabel value="No" control={<Radio />} label="No" />
                            </RadioGroup>
                            {((isSubmitted && !fields.unclearedForeignNationals)) ?
                              <FormHelperText sx={{ marginLeft: 0, marginRight: 0 }}>This field is required</FormHelperText>
                              :
                              <FormHelperText sx={{ marginLeft: 0, marginRight: 0 }}>Select 'Yes' if any visitor is a non-U.S. citizen who does not hold an active DOE security clearance or pre-approved site access.</FormHelperText>
                            }
                          </FormControl>
                        </Box>
                      </Grid>
                    } */}
                    {
                      fields.requestType === 'Meeting' &&
                      <>
                        <Grid item="true" size={{ md: 12, lg: 6 }}>
                          <Box sx={{ backgroundColor: '#f5f9fd', padding: '10px' }}>
                            <FormControl style={{ fontSize: '12px' }}
                              onChange={(event) => {
                                setFields({
                                  ...fields, [event.target.name]: event.target.value,
                                  'otherOfficeName': ''
                                });
                              }}
                              required
                              name='meetingWithOtherOffice'
                              aria-labelledby="meetingWithOtherOffice"
                              error={isSubmitted && !fields.meetingWithOtherOffice}
                            >
                              <FormLabel id="meetingWithOtherOffice">Meeting with other DOE office(s)</FormLabel>
                              <RadioGroup
                                row
                                name='meetingWithOtherOffice'
                                required
                                value={fields.meetingWithOtherOffice}
                              >
                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                <FormControlLabel value="No" control={<Radio />} label="No" />
                              </RadioGroup>
                              {((isSubmitted && !fields.meetingWithOtherOffice)) && (
                                <FormHelperText>This field is required</FormHelperText>
                              )}
                            </FormControl>
                          </Box>
                        </Grid>
                        {
                          fields && fields.meetingWithOtherOffice === 'Yes' &&
                          <Grid item="true" size={{ md: 12, lg: 6 }}>
                            <FormControl fullWidth required>
                              <TextField
                                label="Specify Office Name"
                                required
                                rows={3}
                                name='otherOfficeName'
                                value={fields && fields.otherOfficeName}
                                onChange={handleChange}
                                variant="filled"
                                slotProps={{
                                  htmlInput: { maxLength: 250 }
                                }}
                              />
                            </FormControl>
                          </Grid>
                        }
                      </>
                    }
                    {
                      internalUser &&
                      <Grid item="true" size={{ md: 12, lg: 6 }}>
                        <FormControl fullWidth required>
                          <TextField required
                            label="Note for Executive Assistants"
                            multiline
                            rows={3}
                            name='noteForEA'
                            value={fields && fields.noteForEA}
                            onChange={handleChange}
                            variant="filled"
                            helperText={"Enter “No-Action Item” if no action is required."}
                          />
                        </FormControl>
                      </Grid>
                    }
                    {/* <Grid item="true" size={{ md: 12, lg: 6 }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center', backgroundColor: '#f5f9fd', padding: '10px' }}>
                        <InputLabel htmlFor="idRequestorEmail">BIOS</InputLabel>
                        <FormControl error={file_errorText !== ''} style={{ width: 400, marginRight: '10px' }}>
                          <Button
                            component="label"
                            variant="contained"
                            startIcon={<CloudUploadIcon />}
                          >
                            Upload BIOS
                            <input
                              id="fileForUpload"
                              type="file"
                              hidden
                              onChange={handleFileChange}
                              accept=".pdf"
                            />
                          </Button>
                          <FormHelperText>{file_errorText !== '' ? file_errorText : 'Only PDF files are allowed at this time.'}</FormHelperText>
                        </FormControl>
                        {file && (
                          <Typography variant="body2" color="textSecondary">
                            <b>Selected:</b> {file.name} ({(file.size / 1024).toFixed(1)} KB)
                          </Typography>
                        )}
                      </Box>
                    </Grid> */}
                  </Grid>
                </Box>
              </>
            }

            <br />
            {
              !internalUser &&
              <ReCAPTCHA
                sitekey="6LeKZicUAAAAADTchZtbHUciNtnUKW1OYZUqL2Fr"
                onChange={captchaVerified}
              />
            }
            {submitError &&
              <p style={{ fontSize: '14px', color: 'red' }}>
                Error while submitting form.
                Please contact system administrator at <a href="mailto:HGEOEngagementRequest@doe.gov">HGEOEngagementRequest@doe.gov</a>
              </p>
            }
            <Button type="submit" variant="contained" color="primary" sx={{ mr: 1 }} disabled={(!emailVerified && !internalUser) || (!cpVerified && !internalUser) || saving}>
              {
                saving ? 'Submitting...' : 'Submit'
              }
            </Button>
            {/* <Button type="submit" variant="contained" color="primary" sx={{ mr: 1 }} disabled={saving}>
              {
                saving ? 'Submitting...' : 'Submit'
              }
            </Button> */}
          </form>
        </div>
      }

      {
        formSubmitted &&
        <div>
          <DoneAllIcon />
          <span style={{ fontSize: '20px' }}>&nbsp;&nbsp;&nbsp; Your request was submitted Successfully.</span>
          <br />
          <Link href="#" onClick={() => { window.location.reload(); }} style={{ fontSize: '14px' }}>Submit another request</Link>
        </div>
      }


    </FormContainer >
  );

}
